import React from 'react'
// components
import { ReduxInput, ReduxSlider, ReduxSwitch } from 'components/FormElements'

const SectionFields: React.FC = () => {
  return (
    <>
      <ReduxSwitch label='Drop Shadow' name='dropShadow' />
      <ReduxSwitch label='Show Title' name='showTitle' />
      <ReduxInput label='Title' name='title' />
      <ReduxInput label='Border Padding (Pixels)' name='padding' type='number' />
      <ReduxSlider label='Background Transparency' name='transparency' />
    </>
  )
}

export default SectionFields
